import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL } from './CTAButton';

/**
 * Sticky bottom CTA. Appears once the user scrolls past the first CTA
 * (the element with id `first-cta`) and shakes to stay noticeable.
 */
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('first-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      const passed = entry.boundingClientRect.bottom < 0;
      setVisible(passed);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-ink-500 bg-ink-900/95 px-3 pb-[calc(env(safe-area-inset-bottom)+10px)] pt-3 backdrop-blur transition-[opacity,transform] duration-200 ease-out ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'}`} data-id="element-30" data-mp="2avusalz3l8ad">
      <div className="mx-auto w-full max-w-xl" data-id="element-31" data-mp="2z30l59usf402">
        <a href={CHECKOUT_URL} tabIndex={visible ? 0 : -1} className="block w-full animate-shake rounded-xl bg-flame-500 px-4 py-3.5 text-center font-display text-lg font-extrabold uppercase leading-5 tracking-wide text-ink-900 shadow-[0_6px_0_0_#B13B02] transition-colors duration-150 ease-out hover:bg-flame-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-spark sm:text-xl" data-id="element-32" data-mp="2z4boj8kbm9qn">
          Get instant access — $27
        </a>
        <p className="mt-1.5 text-center text-[10px] font-semibold uppercase tracking-[0.16em] text-zinc-500" data-id="element-33" data-mp="26djtieezrr4w">
          One-time payment · Lifetime access · 7-day guarantee
        </p>
      </div>
    </div>;
}